<template>
  <div class="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-6">
    <div>
      <h5 class="text-sm font-semibold">{{ $t('widgets.sections.snowreport.selected') }}</h5>
      <div class="mt-2 border border-grey rounded-lg p-3 min-h-[120px]">
        <draggable
          v-model="internalSelected"
          handle=".drag-handle"
          class="flex flex-col gap-2"
        >
          <div
            v-for="fieldKey in internalSelected"
            :key="fieldKey"
            class="flex items-center justify-between bg-grey-lightest rounded px-3 py-2"
          >
            <div class="flex items-center gap-2">
              <span class="drag-handle cursor-move text-grey">≡</span>
              <span>{{ fieldLabel(fieldKey) }}</span>
            </div>
            <button class="sk-btn sk-btn-small sk-btn-danger btn-border rounded-lg px-3" @click="removeField(fieldKey)">
              {{ $t('widgets.actions.remove') }}
            </button>
          </div>
        </draggable>
        <div v-if="internalSelected.length === 0" class="text-sm text-grey">
          {{ $t('widgets.sections.snowreport.none_selected') }}
        </div>
      </div>
    </div>

    <div>
      <h5 class="text-sm font-semibold">{{ $t('widgets.sections.snowreport.available') }}</h5>
      <div class="mt-2 border border-grey rounded-lg p-3 min-h-[120px]">
        <div v-if="availableFields.length === 0" class="text-sm text-grey">
          {{ $t('widgets.sections.snowreport.none_available') }}
        </div>
        <div
          v-for="field in availableFields"
          :key="field.key"
          class="flex items-center justify-between bg-white rounded px-2 py-2"
        >
          <span>{{ field.label }}</span>
          <button class="sk-btn sk-btn-small sk-btn-primary btn-border rounded-lg px-3" @click="addField(field.key)">
            {{ $t('widgets.actions.add') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SnowReportFieldsSelector',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalSelected: [],
      allFields: [
        { key: 'open', label: this.$t('snowreport.label.resortstatus') },
        { key: 'avalanche_risk', label: this.$t('snowreport.label.avalancherisk') },
        { key: 'open_slopes', label: this.$t('snowreport.label.openslopes') },
        { key: 'open_lifts', label: this.$t('snowreport.label.openlifts') },
        { key: 'skiable_km', label: this.$t('snowreport.label.distance') },
        { key: 'temp_min', label: this.$t('snowreport.label.mintemperature') },
        { key: 'temp_max', label: this.$t('snowreport.label.maxtemperature') },
        { key: 'wind_speed', label: this.$t('snowreport.label.windspeed') },
        { key: 'min_snow', label: this.$t('snowreport.label.minsnowdepth') },
        { key: 'max_snow', label: this.$t('snowreport.label.maxsnowdepth') },
        { key: 'mid_snow', label: this.$t('snowreport.label.midmountainsnowdepth') },
        { key: 'snowfall_24', label: this.$t('snowreport.label.snowfall24h') },
        { key: 'snowfall_48', label: this.$t('snowreport.label.snowfall48h') },
        { key: 'snowfall_72', label: this.$t('snowreport.label.snowfall72h') },
        { key: 'snowfall_season', label: this.$t('snowreport.label.snowfallseason') },
        { key: 'snowfall_overnight', label: this.$t('snowreport.label.snowfallovernight') },
        { key: 'snow_type', label: this.$t('snowreport.label.snowfallcondition') },
        { key: 'base_snow', label: this.$t('snowreport.label.basesnow') },
        { key: 'new_snow', label: this.$t('snowreport.label.newsnow') },
        { key: 'last_snowfall', label: this.$t('snowreport.label.lastsnowfall') },
        { key: 'season_opening_date', label: this.$t('snowreport.label.seasonopeningdate') },
        { key: 'season_closing_date', label: this.$t('snowreport.label.seasonclosingdate') },
        { key: 'conditions_summary', label: this.$t('snowreport.label.conditionssummary') },
        { key: 'anouncement', label: this.$t('snowreport.label.anouncement') },
        { key: 'resortsummary', label: this.$t('snowreport.label.resortsummary') },
        { key: 'weather_report', label: this.$t('snowreport.label.weatherreport') },
        { key: 'opening_hours', label: this.$t('snowreport.label.openinghours') },
        { key: 'thickness', label: this.$t('widgets.fields.thickness') }
      ]
    }
  },
  watch: {
    value: function (newValue) {
      this.internalSelected = newValue
    }
  },
  computed: {
    availableFields() {
      const selected = new Set(this.internalSelected)
      return this.allFields.filter(field => !selected.has(field.key))
    }
  },
  methods: {
    fieldLabel(fieldKey) {
      const option = this.allFields.find(field => field.key === fieldKey)
      return option ? option.label : fieldKey
    },
    addField(fieldKey) {
      if (!this.internalSelected.includes(fieldKey)) {
        this.internalSelected = [...this.internalSelected, fieldKey]
      }
      this.$emit('input', this.internalSelected)
    },
    removeField(fieldKey) {
      this.internalSelected = this.internalSelected.filter(field => field !== fieldKey)
      this.$emit('input', this.internalSelected)
    }
  }
}
</script>

